export enum InvoiceStatus {
  PAID = 'paid',
  PENDING = 'pending',
  FAILED = 'failed',
}

export const INVOICE_STATUS_I18N_KEYS: Record<InvoiceStatus, string> = {
  [InvoiceStatus.PAID]: 'billing.invoices.statuses.paid',
  [InvoiceStatus.PENDING]: 'billing.invoices.statuses.pending',
  [InvoiceStatus.FAILED]: 'billing.invoices.statuses.failed',
};

export const INVOICE_STATUS_COLOR_CLASS: Record<InvoiceStatus, string> = {
  [InvoiceStatus.PAID]: 'text-status-success',
  [InvoiceStatus.PENDING]: 'text-status-warning',
  [InvoiceStatus.FAILED]: 'text-status-error',
};
